import { createContext, useContext } from "react";
import { useMatch } from "react-router-dom";
import {
  useWhiteLabelingStyling,
  WhiteLabelingStyling,
} from "@verbit-ai/frontend-common";

const WhiteLabelingContext = createContext<WhiteLabelingStyling | null>(null);

export const WhiteLabelingProvider = WhiteLabelingContext.Provider;

export const useWhiteLabelingBrandId = (): string | undefined => {
  const match = useMatch("/bid/:brandId");
  return match?.params.brandId ?? undefined;
};

export const useWhiteLabelingConfigLoader = (): WhiteLabelingStyling | null => {
  const brandId = useWhiteLabelingBrandId();
  return useWhiteLabelingStyling(brandId);
};

export const useWhiteLabelingConfig = (): WhiteLabelingStyling | null => {
  return useContext(WhiteLabelingContext);
};

export const useCustomerLabel = (fallback = "Verbit"): string => {
  const config = useContext(WhiteLabelingContext);
  return config?.customerLabel || fallback;
};
